import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Home, MapPin, Bed, Bath, Maximize, Edit, Trash2 } from 'lucide-react';

/* eslint-disable react/prop-types */
export function LandlordPropertyCard({ property, discountedPrice, canManage, onEdit, onDelete }) {
  return (
    <Card className="property-card overflow-hidden border border-border shadow-sm">
      <div className="relative h-48 overflow-hidden bg-muted">
        {property.images && property.images.length > 0 ? (
          <img src={property.images[0]} alt={property.title} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Home className="w-12 h-12 text-muted-foreground" />
          </div>
        )}
        {property.discount_rate > 0 && (
          <div className="absolute top-3 right-3 bg-accent text-accent-foreground px-3 py-1 rounded-full text-xs font-bold tracking-wide">
            -{property.discount_rate}% OFF
          </div>
        )}
      </div>
      <div className="p-6">
        <h3 className="text-xl font-medium mb-2">{property.title}</h3>
        <div className="flex items-center text-sm text-muted-foreground mb-4">
          <MapPin className="w-4 h-4 mr-1" />
          {property.city}
        </div>
        <div className="flex items-center gap-4 text-sm text-muted-foreground mb-4">
          <div className="flex items-center"><Bed className="w-4 h-4 mr-1" />{property.bedrooms}</div>
          <div className="flex items-center"><Bath className="w-4 h-4 mr-1" />{property.bathrooms}</div>
          <div className="flex items-center"><Maximize className="w-4 h-4 mr-1" />{property.area} sqft</div>
        </div>
        <div className="mb-4">
          <div className="text-2xl font-bold text-primary">
            ${discountedPrice.toFixed(0)}
            <span className="text-sm font-normal text-muted-foreground">/month</span>
          </div>
          {property.discount_rate > 0 && (
            <div className="text-sm text-muted-foreground line-through">${property.price}</div>
          )}
        </div>
        <div className="flex gap-2">
          <Button
            data-testid={`edit-property-${property.id}-btn`}
            onClick={onEdit}
            variant="outline"
            size="sm"
            disabled={!canManage}
            className="flex-1 rounded-full"
          >
            <Edit className="w-4 h-4 mr-1" /> Edit
          </Button>
          <Button
            data-testid={`delete-property-${property.id}-btn`}
            onClick={onDelete}
            variant="destructive"
            size="sm"
            disabled={!canManage}
            className="flex-1 rounded-full"
          >
            <Trash2 className="w-4 h-4 mr-1" /> Delete
          </Button>
        </div>
      </div>
    </Card>
  );
}
/* eslint-enable react/prop-types */
